import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { RoleValidationSchema } from '@/features/tcardRoles/schemas/create.schema'
import { useMutation } from '@tanstack/react-query'

interface UseCreateRoleProps {
  permissions: { permission_id: string }[]
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

const useCreateRole = ({ permissions, onSuccess, onError }: UseCreateRoleProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['createRole'],
    mutationFn: async (form: RoleValidationSchema) => {
      const payload = {
        display_name: form.display_name,
        description: form.description,
        perma_name: null,
        level: Number(form.level) || 0,
        permission_roles_attributes: permissions,
      }

      return privateAxios.post('/roles', { ...payload })
    },
    onSuccess,
    onError,
  })
}

export default useCreateRole
